"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Facebook, Linkedin, ArrowUp, MapPin, Phone, Mail } from "lucide-react";
const services = ["Travailleurs autonomes", "Crédit difficile", "Achat-location", "Sauvetage immobilier", "Refinancement hypothécaire", "Achat d'une propriété"];
function FooterQuickLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <footer data-section-id="264899" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-10 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed font-default">
              Expertise en solutions hypothécaires complexes au Québec. Nous transformons les dossiers difficiles en succès immobiliers grâce à un accompagnement personnalisé et professionnel.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-foreground tracking-tight">Navigation</h3>
            <MenuProvider menu_id="17">
              <FooterQuickLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-foreground tracking-tight">Nos Spécialités</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/nos-programmes/" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-foreground tracking-tight">Contactez-nous</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground text-sm font-default">
                <MapPin className="size-5 text-secondary shrink-0 mt-0.5" />
                <span>Québec, Canada</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm font-default">
                <Phone className="size-5 text-secondary shrink-0" />
                <span>819.943.8841</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm font-default">
                <Mail className="size-5 text-secondary shrink-0" />
                <span>info@hypothequesjennymartel.com</span>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col gap-1">
            <p className="text-muted-foreground text-sm text-center md:text-left font-default">© 2019 Jenny Martel. Tous droits réservés.</p>
            
          </div>
          
          <div className="flex items-center gap-4">
            <Link to="#" className="size-10 rounded-md bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-colors shadow-sm" aria-label="Facebook">
              <Facebook className="size-4" />
            </Link>
            <Link to="#" className="size-10 rounded-md bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-colors shadow-sm" aria-label="LinkedIn">
              <Linkedin className="size-4" />
            </Link>
          </div>

          <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-md border-border hover:bg-secondary hover:text-secondary-foreground hover:border-secondary transition-colors shadow-md" aria-label="Retour en haut">
            <ArrowUp className="size-4" />
          </Button>
        </div>
      </div>
    </footer>;
}